
import { Component, Emit, Prop, Vue, Model } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {}
})
export default class FormInput extends Vue {
  @Prop({ default: '请输入您的昵称' }) readonly placeholder!: string

  @Model('change', { type: String }) readonly value!: string

  get inputValue() {
    return this.value
  }

  set inputValue(val: string) {
    this.$emit('change', val)
  }

  created() {}

  mounted() {}

  updated() {}

  destroyed() {}
}
